import { useCallback, useEffect, useState } from "react";

import { listPendingInvitesAsUser } from "../dashboard-client";

const PENDING_INVITES_REFRESH_EVENT = "pending-invites:refresh";

export function dispatchPendingInvitesRefresh(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new Event(PENDING_INVITES_REFRESH_EVENT));
}

export function usePendingInviteCount(enabled = true) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      return;
    }
    try {
      const pendingResult = await listPendingInvitesAsUser();
      const { invites } = pendingResult.data;
      setCount(invites.length);
    } catch {
      // Keep the previous count on transient API failures.
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    void refresh();
  }, [enabled, refresh]);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      return () => {
        // Ignored
      };
    }

    const onRefresh = () => {
      void refresh();
    };

    window.addEventListener(PENDING_INVITES_REFRESH_EVENT, onRefresh);
    return () => {
      window.removeEventListener(PENDING_INVITES_REFRESH_EVENT, onRefresh);
    };
  }, [enabled, refresh]);

  return { count, refresh };
}
